import NotificationsComponent from './NotificationComponent.vue';

const Notifications = {
  install(Vue, options) {
    Vue.component('notifications-component', NotificationsComponent)
  }
};

export default Notifications;



// WEBPACK FOOTER //
// ./src/Notifications/Notifications.js